import React from 'react';
import CollectorStatusIndicator from '../CollectorStatusIndicator';
import { useTranslation } from 'react-i18next';

type LastResultProps = {
  status: string | null;
};

const statusMap: Record<
  string,
  'green' | 'red' | 'yellow' | 'grey' | undefined
> = {
  disabled: undefined,
  failed: 'red',
  'not run yet': 'grey',
  success: 'green',
};

export default function LastResult({ status }: LastResultProps) {
  const [t] = useTranslation(['asset', 'common']);
  if (!status || status === '-') return <>-</>;
  return (
    <CollectorStatusIndicator
      variant={statusMap[status.toLowerCase()]}
      label={t(status)}
    />
  );
}
